import { createFileRoute } from '@tanstack/react-router';
import Dashboard from 'pages/dashboard/dashboard.component';

export const Route = createFileRoute('/_auth/_layout_with_full_navigation/')({
  component: Dashboard,
});
